<template>
  <router-link to="/bulk">
    <b-icon-upload title="Upload" />
  </router-link>
</template>

<script>
export default {
  name: 'BulkUploadIcon'
}
</script>



// WEBPACK FOOTER //
// src/app/components/Icons/BulkUploadIcon.vue?1c1adab6